import { useEffect, useState } from 'react';
import { api } from '../api/client';

// Modül düzeyi cache — sayfa yaşam döngüsü boyunca bir kez çekilir.
let cached = null;
let inflight = null;

const FALLBACK = {
  pricing: { monthly: 349, quarterly: 899, biannual: 1599, extraServerDiscountPct: 35 },
  plans: {
    extraServerDiscountPct: 35,
    monthly: { months: 1, days: 30, amount: 349 },
    quarterly: { months: 3, days: 90, amount: 899 },
    biannual: { months: 6, days: 180, amount: 1599 },
  },
};

export default function usePublicSettings() {
  const [settings, setSettings] = useState(cached);

  useEffect(() => {
    if (cached) return;
    if (!inflight) inflight = api.publicSettings().catch(() => FALLBACK);
    inflight.then((s) => {
      cached = s || FALLBACK;
      setSettings(cached);
    });
  }, []);

  return settings || FALLBACK;
}

export function invalidatePublicSettings() {
  cached = null;
  inflight = null;
}
